import {useEffect, useMemo, useRef} from 'react';
import {useEvent} from './useEvent';

type UseTimeoutCallback = () => void;

export function useTimeout(callback: UseTimeoutCallback, ms = 0) {
  const timeoutId = useRef<ReturnType<typeof setTimeout>>();
  const memoizedCallback = useEvent(callback);

  const handler = useMemo(() => {
    return {
      start(overrideMs?: number) {
        handler.stop();
        timeoutId.current = setTimeout(
          memoizedCallback,
          overrideMs === undefined ? ms : overrideMs,
        );
      },

      stop() {
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
      },

      restart() {
        handler.stop();
        handler.start();
      },
    };
  }, [memoizedCallback, ms]);

  useEffect(() => {
    return () => {
      handler.stop();
    };
  }, [handler]);

  return handler;
}
